import React from "react";
import { CircularProgress, Hidden } from "@material-ui/core";
import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => ({
  spinner: {
    alignItems: "center", display: "flex", justifyContent: "center"
  },
  spinner2: {
    justifyContent: "center", position: "fixed", top: "50%"
  }
}));

export default function GraphLoader(props) {
  const classes = useStyles();  

  const getSpinner = (spinnerClass) => {
    return (
      <div className={`${spinnerClass} ${classes.spinner}`}>
        <CircularProgress disableShrink />
        <span className={classes.spinner2}></span>
      </div>
    )
  }

  return (
    <div>
        <Hidden xlUp smDown>{getSpinner("spinnerDiv")}</Hidden>
        <Hidden mdUp xsDown>{getSpinner("spinnerDiv1")}</Hidden>
        <Hidden smUp>{getSpinner("spinnerDiv2")}</Hidden>
    </div>
  );
}
